"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Accounts = _interopRequireDefault(require("./Accounts"));
var _Contracts = _interopRequireDefault(require("./Contracts"));
var _Transactions = _interopRequireDefault(require("./Transactions"));
var _Users = _interopRequireDefault(require("./Users"));
var _Tokens = _interopRequireDefault(require("./Tokens"));
var _Network = _interopRequireDefault(require("./Network"));
/**
 * Simple client for API Miner.
 */
class ApiMiner {
  /**
   * Constructor.
   *
   * @param {AxiosInstance} client
   * @param {String} accessToken
   */
  constructor(client, accessToken) {
    (0, _defineProperty2.default)(this, "accounts", void 0);
    (0, _defineProperty2.default)(this, "contracts", void 0);
    (0, _defineProperty2.default)(this, "transactions", void 0);
    (0, _defineProperty2.default)(this, "users", void 0);
    (0, _defineProperty2.default)(this, "tokens", void 0);
    (0, _defineProperty2.default)(this, "network", void 0);
    this.client = client;
    this.accounts = new _Accounts.default(client);
    this.contracts = new _Contracts.default(client);
    this.transactions = new _Transactions.default(client);
    this.users = new _Users.default(client);
    this.tokens = new _Tokens.default(client);
    this.network = new _Network.default(client);
    if (accessToken) {
      client.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    }
  }
}
var _default = exports.default = ApiMiner;
//# sourceMappingURL=ApiMiner.js.map